import { animate, AnimationTriggerMetadata, AUTO_STYLE, keyframes, state, style, transition, trigger } from '@angular/animations';

export const fadeInAndOut = (name: string, easing = 'linear', enterSpeed = '300ms', exitSpeed = '300ms'): AnimationTriggerMetadata => {
  return trigger(name, [
    transition(':enter', [
      style({ opacity: 0 }),
      animate(
        `${enterSpeed} ${easing}`,
        style({
          opacity: 1
        })
      )
    ]),
    transition(':leave', [
      style({ opacity: 1 }),
      animate(
        `${exitSpeed} ${easing}`,
        style({
          opacity: 0
        })
      )
    ])
  ]);
};

export const textFadeSlide = (
  name: string,
  speed: number,
  showStyles: { transform?: string; opacity: number },
  hideStyles: { transform?: string; opacity: number },
  transitionDirection: string,
  easing = 'linear'
): AnimationTriggerMetadata => {
  return trigger(name, [
    state('show', style({ ...showStyles })),
    state('hide', style({ ...hideStyles })),
    transition(`${transitionDirection}`, [animate(`${speed}ms ${easing}`)])
  ]);
};

export const toggleNotification = (name: string, enterSpeed = '350ms', exitSpeed = '300ms'): AnimationTriggerMetadata => {
  return trigger(name, [
    transition(':enter', [
      style({ width: '30px', height: '30px', transform: 'scale(0)', 'border-radius': '50%' }),
      animate(
        `${enterSpeed} ease-out`,
        keyframes([
          style({ width: '50px', height: '50px', transform: 'scale(1)', 'border-radius': '50%', offset: 0.7 }),
          style({ width: AUTO_STYLE, height: AUTO_STYLE, 'border-radius': AUTO_STYLE, offset: 1 })
        ])
      )
    ]),
    transition(':leave', [
      style({ width: AUTO_STYLE, height: AUTO_STYLE, 'border-radius': AUTO_STYLE }),
      animate(
        `${exitSpeed} ease-in`,
        keyframes([
          style({ width: '50px', height: '50px', transform: 'scale(1)', 'border-radius': '50%', offset: 0.7 }),
          style({ width: '30px', height: '30px', 'border-radius': '50%', transform: 'scale(0)', offset: 1 })
        ])
      )
    ])
  ]);
};
